// tslint:disable
export var AccountContactInformationType;
(function (AccountContactInformationType) {
    // UNKN
    AccountContactInformationType[AccountContactInformationType["UNKN"] = 0] = "UNKN";
    // PHONE
    AccountContactInformationType[AccountContactInformationType["PHONE"] = 1] = "PHONE";
    // MOBILE
    AccountContactInformationType[AccountContactInformationType["MOBILE"] = 2] = "MOBILE";
    // FAX
    AccountContactInformationType[AccountContactInformationType["FAX"] = 3] = "FAX";
    // WEB
    AccountContactInformationType[AccountContactInformationType["WEB"] = 4] = "WEB";
    // E-MAIL
    AccountContactInformationType[AccountContactInformationType["EMAIL"] = 5] = "EMAIL";
    // DNC
    AccountContactInformationType[AccountContactInformationType["DNC"] = 6] = "DNC";
    // FACEBOOK
    AccountContactInformationType[AccountContactInformationType["FACEBOOK"] = 7] = "FACEBOOK";
    // TWITTER
    AccountContactInformationType[AccountContactInformationType["TWITTER"] = 8] = "TWITTER";
    // LINKEDIN
    AccountContactInformationType[AccountContactInformationType["LINKEDIN"] = 9] = "LINKEDIN";
    // GOOGLEPLUS
    AccountContactInformationType[AccountContactInformationType["GOOGLEPLUS"] = 10] = "GOOGLEPLUS";
    // YOUTUBE
    AccountContactInformationType[AccountContactInformationType["YOUTUBE"] = 11] = "YOUTUBE";
    // Text
    AccountContactInformationType[AccountContactInformationType["Text"] = 12] = "Text";
    // Mail
    AccountContactInformationType[AccountContactInformationType["Mail"] = 13] = "Mail";
    // MANGO
    AccountContactInformationType[AccountContactInformationType["MANGO"] = 14] = "MANGO";
})(AccountContactInformationType || (AccountContactInformationType = {}));
AccountContactInformationType['TEXT'] = 12;
AccountContactInformationType['MAIL'] = 13;
//# sourceMappingURL=AccountContactInformationType.js.map